/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
import cookie from 'vue-cookie';
import authAPI from '../api/auth';
import userAPI from '../api/user';
import router from '../router';

export default {

  state: {
    recaptcha_site_key: '',
    active_order_id: null,
    user: {
      name: '',
      email: null,
      confirmed: '0',
      status: null,
    },
    token: cookie.get('coach_token') || null,
    loading: false,
  },

  mutations: {
    updateToken(state, data) {
      console.log('mitation updateToken', data);
      cookie.set('coach_token', data.token, { expires: '1Y' });
      cookie.set('coach_refreshToken', data.refresh_token, { expires: '1Y' });

      state.token = data.token;

      console.log('coach_token', cookie.get('coach_token'));
      console.log('coach_refreshToken', cookie.get('coach_refreshToken'));
      console.log('state.token', state.token);
    },

    updateUser(state, data) {
      state.user = data.coach;
      state.active_order_id = data.active_order_id;
    },

    logout(state) {
      console.log('commit logout');
      document.cookie = `coach_refreshToken=; path=/; domain=.zeyplay.com; expires=${new Date(0).toUTCString()}`;
      document.cookie = 'coach_refreshToken=; Max-Age=0';

      document.cookie = `coach_token=; path=/; domain=.zeyplay.com; expires=${new Date(0).toUTCString()}`;
      document.cookie = 'coach_token=; Max-Age=0';

      cookie.delete('coach_token');
      cookie.delete('coach_refreshToken');
      state.token = null;
    },

    authInit(state, data) {
      state.recaptcha_site_key = data.recaptcha_site_key;
    },

    setLoading(state, data) {
      state.loading = data;
    },

    setCoachStatus(state, status) {
      state.user.status = status;
    },
  },

  actions: {
    SET_LOADING: ({ commit }, data) => {
      commit('setLoading', data);
    },

    authInit: ({ commit }, data) => new Promise((resolve, reject) => {
      commit('logout');
      authAPI.init(data)
        .then((response) => {
          if (response.data.success) {
            commit('authInit', response.data.data);
          }
          resolve(response);
        })
        .catch((err) => reject(err));
    }),

    login: ({ commit }, data) => new Promise((resolve, reject) => {
      authAPI.login(data)
        .then((response) => {
          if (response.data.success) {
            commit('updateToken', response.data.data);
          }
          resolve(response);
        })
        .catch((err) => reject(err));
    }),

    loginSocial: ({ commit }, data) => new Promise((resolve, reject) => {
      authAPI.socialAuth(data.socialName, data.params)
        .then((response) => {
          if (response.data.success) {
            console.log('dispatch loginSocial', response.data.data);
            commit('updateToken', response.data.data);
          }
          setTimeout(() => {
            resolve(response);
          }, 1000);
        })
        .catch((err) => reject(err));
    }),

    updateToken: ({ commit, dispatch }) => new Promise((resolve) => {
      const refreshToken = cookie.get('coach_refreshToken');
      authAPI.refreshToken({ refresh_token: refreshToken })
        .then((response) => {
          if (response.data.success) {
            commit('updateToken', response.data.data);
            resolve(response.data.data);
          } else {
            dispatch('logout');
          }
        })
        .catch((error) => {
          console.log(error);
          dispatch('logout');
        });
    }),

    initUser: ({ commit, dispatch }) => new Promise((resolve, reject) => {
      userAPI.init()
        .then((response) => {
          if (response.data.success) {
            commit('updateUser', response.data.data);
          } else {
            dispatch('logout');
          }
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    }),

    emailConfirm: ({ commit }, data) => new Promise((resolve, reject) => {
      authAPI.emailConfirm(data)
        .then((response) => {
          if (response.data.success) {
            commit('updateToken', response.data.data);
          }
          resolve(response);
        })
        .catch((err) => reject(err));
    }),

    logout: ({ commit }) => {
      console.log('dispatch logout');
      commit('logout');
      router.push('/login').catch(() => {});
    },

    SET_STATUS: ({ commit }, data) => new Promise((resolve, reject) => {
      userAPI.changeStatus(data)
        .then((response) => {
          if (response.data.success) {
            commit('setCoachStatus', response.data.data.new_status);
          }
          resolve(response);
        })
        .catch((err) => reject(err));
    }),

    CHECK_STATUS: ({ commit }) => new Promise((resolve, reject) => {
      userAPI.checkStatus()
        .then((response) => {
          if (response.data.success) {
            commit('setCoachStatus', response.data.data.status);
          }
          resolve(response);
        })
        .catch((err) => reject(err));
    }),

    CHECK_NEW_ORDERS: () => userAPI.checkNotifications(),

  },

  getters: {
    user: (state) => state.user,
    isLogged: (state) => (!!state.token),
    needOnboarding: (state) => state.user.confirmed === '0',
    boardingPending: (state) => state.user.confirmed === '1',
    boardingRejected: (state) => state.user.confirmed === '2',
    isApproved: (state) => state.user.confirmed === '3',
    onOrderStatus: (state) => state.user.status === 2,
    token: (state) => state.token,
    isLoading: (state) => state.loading,
    recaptchaKey: (state) => state.recaptcha_site_key,
    activeOrderId: (state) => state.active_order_id,
  },

};
